import React from 'react';
import { Card, ProgressBar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface StatsCardWithProgressProps {
    title: string;
    value: string | number;
    icon?: IconDefinition;
    iconColor?: string;
    valueColor?: string;
    progress?: number; // 0-100
    progressVariant?: string;
    progressHeight?: number;
    className?: string;
    style?: React.CSSProperties;
    showProgressText?: boolean;
}

export default function StatsCardWithProgress({
    title,
    value,
    icon,
    iconColor = "primary",
    valueColor = "primary",
    progress = 0,
    progressVariant = "primary",
    progressHeight = 7,
    className = "",
    style = {},
    showProgressText = false
}: StatsCardWithProgressProps) {
    return (
        <Card className={`h-100 ${className}`} style={style}>
            <Card.Body>
                <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                        <h3 className={`text-${valueColor} fw-bold mb-1`} style={{ fontSize: '1.1rem' }}>
                            {typeof value === 'number' ? value.toLocaleString() : value}
                        </h3>
                        <span className="text-muted" style={{fontSize:'0.7rem'}}>{title}</span>
                    </div>
                    {icon && (
                        <div className="align-self-center ms-3">
                            <FontAwesomeIcon 
                                icon={icon} 
                                className={`text-${iconColor}`} 
                                style={{ fontSize: '2rem' }}
                            />
                        </div>
                    )}
                </div>
                
                {/* Progress Bar */}
                <div className="mt-3 mb-0">
                    <ProgressBar 
                        now={progress} 
                        variant={progressVariant}
                        style={{ height: `${progressHeight}px` }}
                        label={showProgressText ? `${progress}%` : undefined}
                        visuallyHidden={!showProgressText}
                    />
                </div>
            </Card.Body>
        </Card>
    );
}

export type { StatsCardWithProgressProps };
